var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_28_206)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_28_206",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_28_206",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_28_206",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEeklEQVR4nO2dS6hVVRjHl+VVr0UvCiuyIi3CJDUTnVVSkU0qMgzyFkSBTWpSCUJp3Eid2AMKalJBpAMjIsKoQQVWYDpR76DQoCbVpHyUr7r3JwuX4OC217fv3sfzrXP+P9hwOZz1rcfv7rXXXnuvdUIQQgghhBBCCGECuBp4EhgG3k3HcPpspi2KaAQwCXgY2Ek1Y8APwIqYRs3eAYCbDCLGYwcwR1LalXEPcICJcwi4T1LakXEX8C/N+Q+4V1KaybgB+Iv2+BO4XlImLuQL2mebhExMxp10jqWSUl/IxzW6oW3psHZvH0lIPRnTgX8MDbseGDwj3SCw0ZDu7zPTibyQpYZGfaMi/ZuG9LdLhP0MedQwhL2sIv2M9J0qhiTELmR1pjH3G2L8nImxWkLsQtZlGnOvIcbeTIx1EiIhZYLOEF8gIb5AQnyBhPgCCfEFEuILJMQXSIgvkBBfICG+QEJ8gYT4AgnxBRLiCyTEF0iIL5AQXyAhvkBCfIGE+AIJ8QUS0mpjTgMWZo7K92qBtZl3qkYM5RjJxFibST9oqMe04B1gFnkWZmI8k0n/u6Ecf2RiPJ1Jf6uhHrOCd4DLm77oDDxkiLGoIv1iQ/rlmTLcYYgxIxSylCDHI5kY8w0x4rLn88ZJez6wy5D+5kwZhgwxyljSYOguXjKsR//V0CB74upa4IJ03G+4dkR+ya1fT5sQVPFbKAXg20xlPjPEeJ3O8aoh/7giq4rtoRSAdwzrxidnYswEjtI+R4CrMnlPAQ5n4rwdSgF4zNAwdxvibKB9XjHku8wQp5wFP8ah7weGOFOB72iP2JVONeT7oSHWtaEkDAtmjgFXGofR+1uQsc8yTI3dWSpbFbtDaRjutk0X1whwKfBNAxlfxRjBgHEw8WIoDWA2MJqp2HHgRmO8KcDzaV26lfjdZ4EBYx5zgBOZmKNF3KGPB/Cp8b/3nBoxLwGeS9eD8YTHz7YnERfXiHuu8Sz8JPT4evPICxOMfxEwN42KlqW/L+zQQtPT3BZKBvjSUMm4pvyBLpZxuaF7jXweSgdYYKzs0bjhTJf247LcgMY6zAu9APAaNo7Fmd6zWK4VaWBhYVPoFdIM8E/Gio+loedAB8szOV0zLGdu5MdiZnatALekeSQrO6ueeTQox2Lj9PxpYpkXhF4EWEk9RuMUS9yRtIW856YpEetZYXp2UzzAmpoNQmrEeL/yeJxKqZHXFcATwNepK6zLmtAPAC/TjBFgc3zQBayK/8XpWJU+22x8UFXFcOgn0osMdbuPs8FY3+4UlG7I4sMqLxwCHgz9THyuAHzfbROcGnlpT98kZSB1YYe7IOJIuifJPrjqO4BrgPdb2lo8R8zjvZhnt+tdyiPgtxpuwP9/HEi7ll7X7XqWOuUyBGwFDjaUsDXF6q0pkC5fZ5YATwFbDBK2pO8uyb1yJNr5cZccjadbhBEJcQY6Q3yBhPgCCfEFEuILJMQXSIgvkBBfICG+QEJ8gYT4glO/MbUhc/hfQy6EEEIIIYQQQgghRCiXkywDsq60bGCLAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.ac7d0e37abb6299b0d1aae418ab401ca.svg";
export { ForwardRef as ReactComponent };